export default {
    'newsletter.title': 'Buďte prvý, kto sa dozvie',
    'newsletter.btn': 'Prihlásiť sa',
    'newsletter.placeholder': 'Váš e-mail',
    'newsletter.subtitle': 'Zostaňte informovaní a buďte prvý, kto sa dozvie novinky!',
    'instagram.title': 'Sledujte nás',
    'contact.title': 'Potrebujete pomoc?',
    'contact.hours': 'Po - Pi: 9:00 - 19:00',
    'login.title': 'Prihlásenie k účtu',
    'cart.orderRecap': 'Rekapitulácia objednávky',
    "cart.empty": "Váš košík je prázdny",
    "cart.back": "Späť do obchodu",
    "prefix": 'Odoslaním správy súhlasíte s ',
    "privacy": 'zásadami ochrany osobných údajov'
}
